const questions = [

    { id: 1, text: "Promotes a team culture where everyone feels included and valued.", category: "Culture Sensitivity" },
    { id: 2, text: "Open to adopting best practices from other organizational cultures.", category: "Culture Sensitivity" },
    { id: 3, text: "Coaches team to positively adapt to changes.", category: "Culture Sensitivity" },
    { id: 4, text: "Gives feedback meaningfully and in a manner that helps the individual", category: "Coaching for performance" },
    { id: 5, text: "Is easily approachable.", category: "Coaching for performance" },
    { id: 6, text: "Tends to notice people doing things right and acknowledges their actions and accomplishments", category: "Coaching for performance" },
    { id: 7, text: "Manages emotions well", category: "Emotional Intelligence" },
    { id: 8, text: "Mediates and resolves disagreements between team members effectively.", category: "Emotional Intelligence" },
    { id: 9, text: "Avoids engaging in psychological games and aims for straightforward, honest communication.", category: "Emotional Intelligence" },
      
   
   ];
    
    export default questions;